export default __webpack_public_path__ + "static/media/toggle-on-icon.3cdd0e2c.svg";